module.exports = __webpack_public_path__ + "static/img/21a.3327b12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/21a.jpg
// module id = kKm9
// module chunks = 1